/**
 * Configuración de A/B Testing - ADT Landing Page
 * Este archivo contiene todas las configuraciones de tests que pueden ser editadas fácilmente
 */

// ========================================
// CONFIGURACIÓN DEL TEST DE HERO MESSAGE
// ========================================
export const heroMessageConfig = {
    testName: 'hero_message',
    description: 'Test del mensaje principal de la página de inicio',
    variants: {
        control: {
            name: 'control',
            description: 'Mensaje técnico original',
            weight: 50, // Porcentaje de tráfico que recibe esta variante (total debe sumar 100)
            config: {
                title: 'Cotizá tu alarma ADT en muy pocos clicks',
                subtitle: 'Conocé en pocos minutos las mejores opciones de seguridad para tu casa o comercio y contratá tu servicio con profesionales.',
                cta: 'Ver Promos y Precios'
            }
        },
        variant_a: {
            name: 'variant_a',
            description: 'Mensaje emocional con familia',
            weight: 50,
            config: {
                /* title: (location) => {
                    // Aca va el default title 
                    const defaultTitle = 'Últimos días hasta 30% de Descuento 🔥';

                    // Aca viene la lógica para obtener la ciudad desde location o sessionStorage
                    try {
                        const loc = location ?? (typeof window !== 'undefined' ? (function () {
                            const raw = sessionStorage.getItem('ipLocation');
                            return raw ? JSON.parse(raw) : null;
                        })() : null);
                        const city = loc && (loc.city || loc.region || loc.country);
                        // Si tenemos ciudad, usamos "Ciudad - Título"
                        if (city) return `${city} — ${defaultTitle}`;
                    } catch (e) {
                        // Si hay error, simplemente ignoramos y usamos el default
                    }
                    return defaultTitle;
                }, */
                title: 'Últimos días con 30% OFF en tu alarma 🔥',
                subtitle: 'Conocé en pocos minutos las mejores opciones de seguridad para tu casa o comercio y contratá tu sistema monitoreado ahora.',
                cta: 'Cotizá con Descuento'
            }
        },
        variant_b: {
            name: 'variant_b',
            description: 'Mensaje de urgencia con descuento',
            weight: 0,
            config: {
                title: (location) => {
                    // location optional: if not provided, try to read from sessionStorage cache set by IpLocationProvider
                    const defaultTitle = 'Últimos días hasta 30% de Descuento 🔥';
                    try {
                        const loc = location ?? (typeof window !== 'undefined' ? (function () {
                            const raw = sessionStorage.getItem('ipLocation');
                            return raw ? JSON.parse(raw) : null;
                        })() : null);
                        const city = loc && (loc.city || loc.region || loc.country);
                        if (city) return `${city} — ${defaultTitle}`;
                    } catch (e) {
                        // ignore and fallback to default
                    }
                    return defaultTitle;
                },
                subtitle: 'Cotizá en segundos y sin compromiso. Accedé a la mejor tecnología en seguridad con descuentos exclusivos.',
                cta: 'Cotizar con Descuento'
            }
        }
    }
};

// ========================================
// CONFIGURACIÓN DEL TEST DE FORMULARIO
// ========================================
export const formOptimizationConfig = {
    testName: 'form_optimization',
    description: 'Test de optimización del formulario de cotización',
    variants: {
        control: {
            name: 'control',
            description: 'Formulario original de 6 pasos',
            weight: 50, // Gestionado desde backend
            config: {
                totalSteps: 6,
                stepMapping: {
                    1: { questions: ['alarma'], nextStep: 2 },
                    2: { questions: ['adicional'], nextStep: 3 },
                    3: { questions: ['localidad'], nextStep: 4 },
                    4: { questions: ['name'], nextStep: 5 },
                    5: { questions: ['phoneVeri'], nextStep: 6 },
                    6: { questions: ['email'], nextStep: 'loader' }
                },
                questionNumbers: {
                    'alarma': 1,
                    'adicional': 2,
                    'localidad': 3,
                    'name': 4,
                    'phoneVeri': 5,
                    'email': 6
                }
            }
        },
        variant_a: {
            name: 'variant_a',
            description: 'Formulario de 5 pasos: alarma / localidad / WhatsApp / nombre / email',
            weight: 50, // Gestionado desde backend
            config: {
                totalSteps: 5,
                stepMapping: {
                    1: { questions: ['alarma'], nextStep: 2 },
                    2: { questions: ['localidad'], nextStep: 3 },
                    3: { questions: ['phoneVeri'], nextStep: 4 },
                    4: { questions: ['name'], nextStep: 5 },
                    5: { questions: ['email'], nextStep: 'loader' }
                },
                questionNumbers: {
                    'alarma': 1,
                    'localidad': 2,
                    'phoneVeri': 3,
                    'name': 4,
                    'email': 5
                },
            }
        },
        variant_b: {
            name: 'variant_b',
            description: 'Formulario 6 pasos con teléfono al final (progressive commitment)',
            weight: 0, // Gestionado desde backend
            config: {
                totalSteps: 6,
                stepMapping: {
                    1: { questions: ['alarma'], nextStep: 2 },
                    2: { questions: ['adicional'], nextStep: 3 },
                    3: { questions: ['localidad'], nextStep: 4 },
                    4: { questions: ['name'], nextStep: 5 },
                    5: { questions: ['email'], nextStep: 6 },
                    6: { questions: ['phoneVeri'], nextStep: 'loader' }
                },
                questionNumbers: {
                    'alarma': 1,
                    'adicional': 2,
                    'localidad': 3,
                    'name': 4,
                    'email': 5,
                    'phoneVeri': 6
                }
            }
        }
    }
};

// ========================================
// CONFIGURACIÓN DE TRACKING
// ========================================
export const trackingConfig = {
    // Facebook Pixel
    facebook: {
        enabled: false
    },

    // Google Analytics Events
    analytics: {
        enabled: true,
        events: {
            pageView: 'page_view',
            variantExposure: 'ab_test_variant_exposed',
            formStart: 'begin_checkout',
            formComplete: 'purchase',
            formStep: 'add_to_cart'
        }
    },

};

// ========================================
// CONFIGURACIÓN GENERAL
// ========================================
export const generalConfig = {
    // Activar/desactivar todo el sistema de A/B testing
    enabled: true,

    // Mostrar logs en desarrollo
    debug: process.env.NODE_ENV === 'development',

    // Duración de la sesión en días
    sessionDuration: 30,

    // Forzar HTTPS en producción
    forceHTTPS: process.env.NODE_ENV === 'production',

    // Split global (afecta todos los tests)
    globalSplit: 'auto', // 'auto', 'a', 'b' o 'control'

    // Lista de tests activos
    activeTests: [
        'hero_message',
        'form_optimization'
    ]
};

// ========================================
// CONFIGURACIÓN PARA EL CLIENTE
// ========================================
export const clientInstructions = {
    readme: `
    ===== INSTRUCCIONES PARA EDITAR A/B TESTS =====
    
    Este archivo contiene todas las configuraciones de A/B testing.
    
    IMPORTANTE: 
    - Los pesos (weight) de todas las variantes de un test deben sumar 100
    - Siempre mantén al menos una variante 'control' como respaldo
    - Los nombres de variantes no deben contener espacios
    
    PARA EDITAR MENSAJES DEL HERO:
    1. Ve a 'heroMessageConfig.variants'
    2. Edita title, subtitle y cta de cada variante
    3. Ajusta los pesos si querés cambiar el tráfico
    
    PARA EDITAR EL FORMULARIO:
    1. Ve a 'formOptimizationConfig.variants'
    2. Edita los steps, titles y descriptions
    3. Podés cambiar qué preguntas van en cada paso usando 'stepMapping'
    4. Podés cambiar el orden de numeración con 'questionNumbers'
    
    PREGUNTAS DISPONIBLES PARA EL FORMULARIO:
    - 'alarma': ¿Qué querés proteger? (Casa/Depto/Comercio)
    - 'accesos': ¿Cuántos accesos tiene?
    - 'name': Nombre del usuario
    - 'phoneVeri': Teléfono/WhatsApp (con validación)
    - 'localidad': Localidad/Ciudad
    - 'email': Email del usuario
    
    PARA ACTIVAR/DESACTIVAR TESTS:
    1. Ve a 'generalConfig.activeTests'
    2. Agregá o sacá tests de la lista
    
    PARA VER LOS TESTS EN FUNCIONAMIENTO:
    - Agregá ?debug=1 a la URL para ver el panel de debug
    - Agregá ?hero_message=variant_a para forzar una variante específica del hero
    - Agregá ?form=variant_a para forzar una variante específica del formulario
    `
};